export class AssetSave {
    id: number;
    invNo: string;
    subNo: string;
    invNoOld: string;
    name: string;
    serialNumber: string;
    agreement: string;
    manufacturer: string;
    sapCode: string;
    license: string;
    erpCode: string;
    info: string;

    documentTypeId: number;
    documentId: number;
    docNo1: string;
    docNo2: string;
    documentDate: Date;
    //partnerId: number;
    partnerDate: Date;
    assetTypeId: number;
    // accStateId: number;

    // costCenterId: number;
    // assetClassId: number;
  

    assetCategoryId: number;
    //administrationId: number;
    dictionaryItemId: number;
    //employeeId: number;
    roomId: number;
    quantity: number;

    validated: boolean;
    purchaseDate: Date;
    partner: string;
    invState: string;
    details: string;
    model: string;
    invStateId: number;
    costCenterId : number;
    departmentId: number;
    partnerId: number;
    companyId: number;
    orderId: number;
    budgetId: number;
    uomId: number;
    receptionDate: Date;
    invoiceDate: Date;
    poDate: Date;
    removalDate: Date;
    //subTypeId: number;
    insuranceCategoryId: number;
    modelId: number;
    brandId: number;
    projectId: number;
    employeeId: number;
    assetNatureId: number;
    budgetManagerId: number;
    //interCompanyId: number;
    dimensionId: number;
    interCompanyId: number;
    modelInv: string;
    producerInv: string;
    isAccepted : boolean;


    depPeriodMonth: number;
    depPeriod: number;
    depPeriodIn: number;
    depPeriodRem: number;
    valueInvIn: number;
    valueDepIn: number;
    valueDepPU: number;
    valueDepYTDIn: number;
    valueDepYTD: number;
    valueRet: number;
    valueRetIn: number;
    valueDepPUIn: number;
    valueTr: number;
    valueTrIn: number;
    valueRem: number;
    valueRemIn: number;
    investSupport: number;
    writeUps: number;
    valueInv: number;
    valueDep: number;

    admCenterId: number;
    regionId: number;
    divisionId: number;
    accountId: number;
    expAccountId: number;
}
